<template>
  <div
    :class="
      `card card-alert  ${
        alert.type ? 'card-alert-' + alert.type : ''
      } card-alert-float my-3 ${hide ? 'hidden' : ''}`
    "
  >
    <i
      v-if="alert.type == 'success'"
      class="material-symbols-outlined alert-icon"
      >check_circle</i
    >
    <i
      v-else-if="alert.type == 'info'"
      class="material-symbols-outlined alert-icon"
      >info</i
    >
    <i
      v-else-if="alert.type == 'warning'"
      class="material-symbols-outlined alert-icon"
      >report</i
    >
    <i
      v-else-if="alert.type == 'danger'"
      class="material-symbols-outlined alert-icon"
      >report_problem</i
    >
    <i v-else class="material-symbols-outlined alert-icon">check_circle</i>
    <div class="alert-content">
      <h4
        v-if="alert.title"
        :class="`alert-title ${!alert.content ? 'mb-0' : 'mb-1'}`"
      >
        {{ alert.title }}
      </h4>
      <p v-if="alert.content" class="alert-desc">
        {{ alert.content }}
      </p>
    </div>
    <button id="closeAlert" class="alert-close" @click="hideAlert">
      <i class="material-symbols-outlined">close</i>
    </button>
  </div>
</template>
<style>
.card-alert-float {
  position: fixed !important;
  width: 50vw;
  z-index: 99999;
  top: 0rem;
  right: 0rem;
  box-shadow: 0px 0px 32px rgba(0, 0, 0, 0.2);
}
</style>
<script>
export default {
  name: "Alert",
  components: {},
  props: {
    alert: Object,
  },
  data: function() {
    return {
      hide: alert.hide,
    };
  },
  methods: {
    hideAlert() {
      this.hide = true;
      ////console.log(this.hide);
    },
  },
};
</script>
